export const ADMIN_ENDPOINT = "/api/v1/admin";

export function failureToErrors(
	failureHandler,
	defaultMessage = "An unexpected error occurred. Please try again later.",
) {
	return (jqXHR) => {
		const error =
			jqXHR.responseJSON && jqXHR.responseJSON.error
				? jqXHR.responseJSON.error
				: {
						code: "unexpected_error",
						message: defaultMessage,
					};
		failureHandler([error]);
	};
}
